import React from "react";
import { NavLink } from "react-router-dom";

export function BottomNav({ tabs }) {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 h-[76px] bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-[0_-2px_20px_rgba(0,0,0,0.05)] px-2 flex items-center justify-around max-w-lg mx-auto lg:hidden"
    >
      {tabs.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.id}
            to={t.to}
            end={t.end}
            data-testid={`nav-${t.id}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 w-full py-2 rounded-xl transition-colors ${
                isActive ? "text-[#9A462B]" : "text-slate-400"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div className={`p-1.5 rounded-xl transition-colors ${isActive ? "bg-[#F9EFEA]" : ""}`}>
                  <Icon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 2} />
                </div>
                <span className="text-[11px] font-bold">{t.label}</span>
              </>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
